import React, { useState, useRef } from "react";
import { Container, Row, Col, Button, Card, Badge } from 'react-bootstrap';
import ReactPlayer from "react-player";
import cameraImgSt from "../../../common/images/imgShrt.jpg";
import HlsPlayer from "./HlsPlayer";
import { CameraModalPopup } from "./CameraModalPopup";

const canLoadInIframe = (url) => {
  if (!url) return false;
  console.log('url123', url);
  try {
    const parsed = new URL(url);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};

const canLoadRTSP = (url) => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return parsed.protocol === "rtsp:";
  } catch {
    return false;
  }
};


const CameraGridView = ({ cameraData={} }) => {

  const [showDetails, setShowDetails] = useState(false);
  const [rowData, setRowData] = useState([]);

  const handleViewDetail = (rowDetails) => {
        setRowData(rowDetails);
        setShowDetails(true);
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const loadWebcamFun = (camera) => {
         if(canLoadRTSP(camera.streamingUrl) && canLoadInIframe(camera.convertedStreamingUrl)) {
            return (<HlsPlayer streamingurl={camera.convertedStreamingUrl} />);
         } else if(canLoadInIframe(camera.streamingUrl)) {
              return (<iframe
              src={camera?.streamingUrl}
              title={camera?.name}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />);
         } else {
            return (<div className="unsupported-stream">
                    Unsupported Stream Type
                  </div>);
         }
  }

  return (<Container fluid className="camera-container">

     {(cameraData) && <Row className="g-3">
            {cameraData.map((camera, index) => (
              <Col 
                key={camera.id} 
                xs={12} 
                sm={6} 
                md={4} 
                lg={4}
                xl={4}
              >
                <Card className={`camera-card grid-vw-card`}>
                  <div className="camera-image-wrapper">
                    <div className="camera-iframe-wrapper">
                      {loadWebcamFun(camera)}
                    </div>
                    <Badge bg="danger" className="live-badge">
                      <span className="live-indicator"></span> LIVE RECORDING
                    </Badge>
                    <div className="camera-overlay">
                      <div className="camera-info">
                        <div className="camera-name">{camera.name}</div>
                        <div className="camera-location">{camera.model}</div>
                      </div>
                      <div className="camera-menu" onClick={() => handleViewDetail(camera)}>⋮</div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
    </Row>}
      
    <CameraModalPopup
        show={showDetails}
        onHide={handleDetailCancel}
        resultdata={rowData}
    />

  </Container>);
};

export default CameraGridView;
